import {
  FETCH_ALL_ATTACHMENTS,
  UPDATE_ALL_ATTACHMENTS,
  UPDATE_ATTACHMENT_INPUT_SELECTION_ERROR,
  UPDATE_ATTACHMENT_UPLOAD_ERROR,
  UPDATE_ATTACHMENT_UPLOAD_PROGRESS,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE_CURRENT_JOB_INDEX,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE_TOTAL_JOBS,
  UPDATE_ATTACHMENT_WIDGET_ACTIVE,
  UPDATE_CREATE_ATTACHMENT_WITH_TIMESTAMP,
} from 'constants/actions';

const DEFAULT_STATE = {
  attachments: [],
  createWithTimestamp: true,
  widget_active: false,

  fetching: true,
  fetched_once: false,

  input_selection_error: null,

  upload_queue_current_job_index: 0, // 1-based
  upload_queue_total_jobs: 0,
  upload_queue: [],
  upload_progress: 0,
  upload_error: null,
};

const attachmentsReducer = (state = DEFAULT_STATE, action) => {
  let newState;

  switch (action.type) {
    case FETCH_ALL_ATTACHMENTS:
      newState = {
        ...state,
        fetching: action.fetching,
      };
      break;
    case UPDATE_ALL_ATTACHMENTS:
      newState = {
        ...state,
        attachments: action.attachments,
        fetching: false,
        fetched_once: true,
      };
      break;
    case UPDATE_ATTACHMENT_INPUT_SELECTION_ERROR:
      newState = {
        ...state,
        input_selection_error: action.err,
      };
      break;
    case UPDATE_ATTACHMENT_UPLOAD_ERROR:
      newState = {
        ...state,
        upload_error: action.err,
      };
      break;
    case UPDATE_ATTACHMENT_UPLOAD_PROGRESS:
      newState = {
        ...state,
        upload_progress: action.progress,
      };
      break;
    case UPDATE_ATTACHMENT_UPLOAD_QUEUE:
      newState = {
        ...state,
        upload_queue: action.attachments,
      };
      break;
    case UPDATE_ATTACHMENT_UPLOAD_QUEUE_CURRENT_JOB_INDEX:
      newState = {
        ...state,
        upload_queue_current_job_index: action.currentJobIndex,
      };
      break;
    case UPDATE_ATTACHMENT_UPLOAD_QUEUE_TOTAL_JOBS:
      newState = {
        ...state,
        upload_queue_total_jobs: action.totalJobs,
      };
      break;
    case UPDATE_ATTACHMENT_WIDGET_ACTIVE:
      newState = {
        ...state,
        widget_active: action.active,
      };
      break;
    case UPDATE_CREATE_ATTACHMENT_WITH_TIMESTAMP:
      newState = {
        ...state,
        createWithTimestamp: action.include,
      };
      break;
    default:
      newState = state;
  }

  newState.showUploadAttachmentProgressModal = newState.upload_queue.length > 0;

  return newState;
};

export default attachmentsReducer;
